import { API } from '../../../../services';
import {
  ApiInterestProvidersResponse,
  ApiMortgageTypesResponse,
  ApiNhgResponse
} from '../../../../@types';

const fetchNhg = async (): Promise<ApiNhgResponse> => {
  return API.get<ApiNhgResponse>('nhg');
};

const fetchMortgageTypes = async (queryString = 'showAll=true') => {
  return API.get<ApiMortgageTypesResponse>(`interestrates/getmortgagetypes/?${queryString}`);
};

const fetchInterestProviders = async (queryString: string) => {
  return API.get<ApiInterestProvidersResponse>(`interestrates/hypotheekaanbieders/?${queryString}`);
};

export { fetchNhg, fetchMortgageTypes, fetchInterestProviders };
